
import { Context } from '@nuxt/types'
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'
import { defineComponent } from 'vue'
import { PageData } from '@interfaces/PageDataTypes'

export default defineComponent({
  name: 'CareersPage',
  layout: 'machinations',
  extends: MachinationsLightPage,
  head() {
    // @ts-ignore
    const pageHead = this.pageHead()
    const pageData = this.pageData as PageData
    const yoastDescription = pageData?.yoast_head_json?.description
    return {
      ...pageHead,
      //@ts-ignore
      title: `Careers`,
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          content: `Careers`,
        },
        {
          hid: 'description',
          name: 'description',
          content: yoastDescription,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: yoastDescription,
        },
        ...pageHead?.meta,
      ],
    }
  },
  async asyncData(context: Context) {
    const { store } = context

    const pageData = await store.dispatch('wp/fetchPageBySlug', {
      context,
      slug: 'careerspage',
    })
    await store.dispatch('common/setupPageLight', { context })
    store.commit('common/updateIsHomepage', true)
    store.commit('common/isBusy', false)

    return {
      pageData,
    }
  },
})
